<template>
  <div v-bind:class="{'spinner-is-visible': isSpinnerVisible }">
    <div class="progress entity-details-progress">
      <div class="progress-bar progress-bar-success" :style="{ width: progress + '%' }"></div>
    </div>
    <div v-bind:class="['entity-details', {'hidden': !isLoaded }]">
      <section>
        <div class="photo-gallery">
          <photos
            :photos="photos"
            :gallery="entityId"
            :user-can-update="userCanUpdate"
            entity-type="remediation"
            @update-photo="fetchRemediationPhotos"
            @progress="uploadProgress"
          ></photos>
        </div>
      </section>
    </div>
    <div class="spinner"></div>
  </div>
</template>

<script>
import Vue from "vue";
import EntityDetails from "./entity_details";
import Photos from "./photos";

export default {
  extends: EntityDetails,

  components: {
    Photos
  },

  props: {
    entityId: String,
    userCanUpdate: Boolean
  },

  data() {
    return {
      remediation: {},
      progress: 0,
      photos: [],
      isLoaded: false,
      isSpinnerVisible: true
    }
  },

  watch: {
    entityId: function() {
      this.fetchRemediationPhotos();
    }
  },

  mounted: function() {
    this.fetchRemediationPhotos();
  },

  methods: {
    uploadProgress: function(progress) {
      this.progress = progress;
    },

    fetchRemediationPhotos: function() {
      const vmMap = this;
      const fetchedPhotos = [];

      let fetchParams = {
        pageSize: 100,
        filter: {
          remediationId: this.entityId
        }
      };

      this.photos = [];

      this.isLoaded = false;
      this.isSpinnerVisible = true;

      let fetch = (cursor, success) => {
        fetchParams.cursor = cursor;

        app.graphql.get(
          "details.remediationPhotos",

          fetchParams,

          (data) => {
            let photos = data.data.remediationPhotos,
                pageInfo = photos.pageInfo;

            success(photos, pageInfo);
          },

          (error) => {
            app.ui.toast.add({
              priority: "danger",
              title: "Photos",
              message: "Unable to fetch Remediation photos!"
            });
          }
        )
      };

      let getPhotos = (cursor) => {
        fetch(
          cursor,

          (photos, pageInfo) => {
            photos.edges.forEach((photo) => fetchedPhotos.push(photo.node));

            if (pageInfo.hasNextPage && pageInfo.endCursor) {
              getPhotos(pageInfo.endCursor);
            }
            else {
              this.photos = fetchedPhotos;
              this.isLoaded = true;

              setTimeout(() => {
                this.isSpinnerVisible = false;
              }, 1000);
            }
          }
        );
      };

      getPhotos(window.btoa(0));
    },
  }
}

</script>